/**
 * Tracks whether the app is in the startup phase.
 * Used to determine if JS errors should be reported as startup errors to native.
 *
 * The startup phase begins when the app loads and ends when FULL_STARTUP_SUCCESS is emitted.
 *
 * TODO DIA-86002: This module uses a global variable to track startup state, which is not ideal.
 * It should be refactored to use Redux state instead for better testability, predictability,
 * and consistency with the rest of the application's state management.
 * The current approach was chosen to avoid scope creep, but should be addressed in a future PR.
 */
let isInStartupPhase = true

export const startupPhase = {
  /**
   * Check if currently in startup phase
   */
  isActive: (): boolean => isInStartupPhase,

  /**
   * Mark startup as complete
   * Called when FULL_STARTUP_SUCCESS is emitted
   */
  complete: (): void => {
    isInStartupPhase = false
  },

  /**
   * Reset to startup phase (for testing/development)
   */
  reset: (): void => {
    isInStartupPhase = true
  },
}
